import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home = () => {
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    const getGreeting = () => {
      const hour = new Date().getHours();
      if (hour < 12) {
        setGreeting('Good morning');
      } else if (hour < 17) {
        setGreeting('Good afternoon');
      } else {
        setGreeting('Good evening');
      }
    };

    getGreeting();
  }, []);

  return (
    <Container className="py-5">
      <Row>
        <Col>
          <div className="p-5 mb-4 bg-light border rounded-3">
            <div className="container-fluid py-5">
              <h1 className="display-5 fw-bold" id="greeting">{greeting}</h1>
              <p className="col-md-8 fs-4">
                I'm a passionate Software Engineer with a love for technology and continuous learning. 
                Welcome to my personal website where I showcase my work, experiences, and share knowledge.
              </p>
              <Link to="/portfolio">
                <Button variant="success" size="lg">
                  View My Portfolio
                </Button>
              </Link>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="align-items-md-stretch">
        <Col md={6}>
          <Card className="h-100 border-danger">
            <Card.Body className="p-5">
              <Card.Title as="h2" className="text-danger">
                <i className="bi bi-youtube"></i> YouTube Channel
              </Card.Title>
              <Card.Text>
                Check out my coding tutorials and educational content on YouTube. 
                I share practical programming tips, project walkthroughs, and insights 
                from my software engineering journey.
              </Card.Text>
              <Button variant="outline-danger" href="https://www.youtube.com/@codingwithronaldo4496/videos" target="_blank">
                Watch Videos
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="h-100 border-primary mt-4 mt-md-0">
            <Card.Body className="p-5">
              <Card.Title as="h2" className="text-primary">Revision Notes</Card.Title>
              <Card.Text>
                I believe in sharing knowledge and helping others learn. 
                Check out my collection of revision notes and educational resources.
              </Card.Text>
              <Link to="/revision-notes">
                <Button variant="outline-primary">
                  Browse Notes
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col>
          <Card className="bg-light">
            <Card.Body className="p-4">
              <Card.Title as="h3">About Me</Card.Title>
              <Card.Text>
                I'm a dedicated Software Engineer with experience in various technologies and frameworks. 
                My journey in software development has been driven by curiosity and a desire to create 
                meaningful solutions. When I'm not coding, you can find me exploring new technologies, 
                creating educational content, or sharing knowledge with the community.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Home; 